<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <!-- 1 -->
    <block-label :label="'1. KEBIJAKAN, KEPEMIMPINAN & KOMITMEN'" />
    <plain-label :label="'Berikan penjelasan rinci mengenai komitmen pimpinan melalui Kebijakan Kesehatan, Keselamatan Kerja dan Lingkungan (K3L) dan Kebijakan Khusus lainnya di perusahaan Anda.'
      " />
    <input-area :storeName="'k3lStore'" :modelName="'textGrup1'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti dokumen kebijakan K3L & Kebijakan Khusus (Kebijakan Mutu, Kebijakan Larangan Narkotika, Minuman Beralkohol, Merokok dan Pencegahan HIV-AIDS, Kebijakan SR, dll'
      " />
    <upload-file :modelName="'kebijakanFile'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="4"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti implementasi dokumen kebijakan K3L & Kebijakan Khusus kepada karyawan (Minimal 3 Bukti dalam 1 Dokumen, contoh: Sosialisasi, Form absensi sesuai materi dan Foto dokumentasi)'
      " />
    <upload-file :modelName="'buktiKebijakanFile'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="5" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <!-- 2 -->
    <block-label :label="'2. MANAJEMEN RISIKO'" />
    <plain-label :label="'Berikan penjelasan rinci pengaturan mengenai pengelolahan Manajemen Risiko (HIRA) di perusahaan anda'
      " />
    <input-area :storeName="'k3lStore'" :modelName="'textGrup2'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan SOP HIRA & matriks penilaian risiko'" />
    <upload-file :modelName="'hiraFile'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="6"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti statement/policy mengenai perlunya melakukan penilaian bahaya K3 dan lingkungan, dan memiliki prosedur yang jelas mekanisme pengaturan penilaian bahaya/risk Assesment/HIRA/IBPR'
      " />
    <upload-file :modelName="'policyFile'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="7"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <!-- 2.2 -->
    <plain-label :label="'Berikan penjelasan inti mengenai aktifitas/kegiatan apa saja yang telah dilakukan Analisis Risiko (HIRA) dan Analisa Kesehatan (JSA) berikut pengendaliannya'
      " />
    <input-area :storeName="'k3lStore'" :modelName="'textGrup22'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti dokumen risk assessment/HIRA/IBPR sesuai dengan jenis pekerjaan yang dilakukan, revisi terbaru dan terdapat persetujuan manajemen'
      " />
    <upload-file :modelName="'riskFile'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="8"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti implementasi sosialisasi risk assessment /HIRA/IBPR kepada pekerja (Form absensi dan Foto Dokumentasi)'
      " />
    <upload-file :modelName="'implementasiRiskFile'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="9" :disabled="$store.state.k3lStore.is_sipm_approved" />
    <!-- 3 -->
    <block-label :label="'3. MANUAL K3L'" />
    <plain-label :label="'Berikan penjelasan rinci mengenai Manual atau Pedoman Sistem Pengelolaan K3L sesuai lingkup operasional perusahaan'
      " />
    <input-area :storeName="'k3lStore'" :modelName="'textGrup3'" :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan dokumen Manual Keselamatan Kerja, Kesehatan, dan Perlingdungan Lingkungan yang telah disetujui oleh manajemen'
      " />
    <upload-file :modelName="'manualFile'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'" :docId="10"
      :disabled="$store.state.k3lStore.is_sipm_approved" />
    <plain-label :label="'Lampirkan bukti implementasi sosialisasi Manual K3L/SMK3L kepada pekerja (Form absensi dan Foto Dokumentasi)'
      " />
    <upload-file :modelName="'implementasiManual'" :mutationName="'k3lStore/SET_K3L_FORM'" :storeName="'k3lStore'"
      :docId="11" :disabled="$store.state.k3lStore.is_sipm_approved" />

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan dan Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputArea from '../../components/forms/input/input-area.vue'
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import PlainLabel from '../../components/forms/label/plainLabel.vue'
import UploadFile from '../../components/forms/input/multiple_upload.vue'
export default {
  components: {
    BlockLabel,
    PlainLabel,
    InputArea,
    UploadFile,
  },
  data() {
    return {}
  },
  methods: {
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'dokumentasi' })
    },
    goNext() {
      this.$store.commit('k3lStore/SAVE_DRAFT_VENDOR_INPUT', {
        onSuccess: () => {
          this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup46' })
        }
      })
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
